import {
  ADD_CLIENT,
  DELETE_CLIENT,
  GET_CLIENT,
  GET_CLIENTS_LIST,
  HIDE_CLIENT_LOADER,
  HIDE_CLIENTS_LIST_LOADER,
  SET_CLIENT,
  SET_CLIENTS_LIST,
  SET_ERROR_CLIENT,
  SHOW_CLIENT_LOADER,
  SHOW_CLIENTS_LIST_LOADER,
  UPDATE_CLIENT
} from "./actionTypes";

export const getClientsList = data => ({
  type: GET_CLIENTS_LIST,
  payload: data
});

export const setClientsList = payload => ({
  type: SET_CLIENTS_LIST,
  payload
});

export const showClientsListLoader = () => ({
  type: SHOW_CLIENTS_LIST_LOADER
});

export const hideClientsListLoader = () => ({
  type: HIDE_CLIENTS_LIST_LOADER
});

export const deleteClient = (id, data = {}) => ({
  type: DELETE_CLIENT,
  payload: {id, data}
});

export const addClient = (data, documents, history) => ({
  type: ADD_CLIENT,
  payload: { data, documents, history }
});

export const getClientById = id => ({
  type: GET_CLIENT,
  payload: id,
});

export const setClient = (data = {}) => ({
  type: SET_CLIENT,
  payload: data,
});

export const patchClient = (id, data = {}, docs = []) => ({
  type: UPDATE_CLIENT,
  payload: { id, data, docs },
});

export const showClientLoader = () => ({
  type: SHOW_CLIENT_LOADER,
});

export const hideClientLoader = () => ({
  type: HIDE_CLIENT_LOADER,
});

export const setErrorClient = status => ({
  type: SET_ERROR_CLIENT,
  payload: status,
});
